import { TODO_LOCK_MESSAGES } from "@/components/forms/TodoSubmissionRules/constants";
import type { HousingQuestionnaireLockReason } from "./types";

export const HOUSING_FULFILLED_LOCK_REASON = "housingFulfilled" as const;

export const HOUSING_QUESTIONNAIRE_LOCK_MESSAGES: Record<HousingQuestionnaireLockReason, string> = {
  ...TODO_LOCK_MESSAGES,
  [HOUSING_FULFILLED_LOCK_REASON]:
    "The Housing Questionnaire submission window is closed. The fields below cannot be edited anymore because your housing has been fulfilled.",
};
